<template>
  <el-row>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; height: 24rem; padding-top: 5rem; background: url('../../../static/images/BIM_bg.png') center bottom / 120%">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 1108px">
          <div style="display: flex; justify-content: center; align-items: flex-start; flex-flow: column">
            <el-image src="../../../static/images/BIMFamilyLibWeb/BIMFamilyLibWeb_logo.png" style="height: 2.5rem"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 1rem; font-weight: 700; color: #0b4070; margin: 1rem 0 1.5rem">
              <span>管理标准构件</span>
              <span style="display: inline-block; width: 1px; background: rgba(0,0,0,0.33); height: 1.3125rem; margin: 0 0.75rem"></span>
              <span>提高设计效率</span>
              <span style="display: inline-block; width: 1px; background: rgba(0,0,0,0.33); height: 1.3125rem; margin: 0 0.75rem"></span>
              <span>保护知识产权</span>
            </div>
          </div>
        <el-image src="../../../static/images/BIMFamilyLibWeb/BIMMember_01.png" style="height: 15rem"></el-image>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; padding-top: 5rem; flex-flow: column">
        <div style="display: flex; justify-content: center; align-items: center; width: 1108px; flex-wrap: nowrap">
          <el-image style="width: 20rem; margin-right: 3rem"
                    src="../../../static/images/BIMFamilyLibWeb/BIMFamilyLibWeb_1.png"
                    fit="cover"></el-image>
          <div style="display: flex; justify-content: center; align-items: flex-start; flex-flow: column">
            <div style="display: flex; justify-content: center; align-items: center; font-size: 1.25rem; color: #222; font-weight: 700; margin: 1rem 0">
              作为基础数据库，建立BIM标准
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 14px; color: #666; font-weight: 400; line-height: 1.5rem; width: 25rem; text-align: left">
              BIM构件库作为基础数据库，有利于企业建立BIM标准，通过不断积累标准构件，提高建模人员的设计效率，降低设计成本，保护企业知识产权
            </div>
          </div>
        </div>
        <div style="margin: 7rem 0; display: flex; justify-content: center; align-items: center">
          <span style="display: inline-block; width: 12rem; height: 2px; background: linear-gradient(90deg,rgba(255,255,255,0), #bababa)"></span>
          <span style="margin: 0 2rem; font-size: 1rem; font-weight: 700; color: #888">功能简介</span>
          <span style="display: inline-block; width: 12rem; height: 2px; background: linear-gradient(to left, rgba(255,255,255,0), #bababa)"></span>
        </div>
        <div style="display: flex; justify-content: center; align-items: center; flex-flow: column; padding-bottom: 8rem">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 0 0 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">上传族</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>上传Revit族到构件库，进行数模分离</li>
                  <li>支持加密族文件</li>
                </ul>
              </div>
            </div>
            <el-image src="../../../static/images/BIMFamilyLibWeb/BIMFamilyLibWeb_001.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <el-image src="../../../static/images/BIMFamilyLibWeb/BIMFamilyLibWeb_002.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">布置族</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>快速过滤和查找族，下载并布置到Revit项目</li>
                  <li>显示最近使用的族</li>
                </ul>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">族列表</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>按专业、分类管理族</li>
                  <li>查看族属性、下载族文件</li>
                </ul>
              </div>
            </div>
            <el-image src="../../../static/images/BIMFamilyLibWeb/BIMFamilyLibWeb_003.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <el-image src="../../../static/images/BIMFamilyLibWeb/BIMFamilyLibWeb_004.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">产品库</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>支持上传、下载标准产品，如户型、核心筒等</li>
                </ul>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">知识库</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>分类管理知识库文件</li>
                  <li>批量上传文件、文件夹；移动、复制文件及文件夹</li>
                  <li>支持在线查看文件</li>
                </ul>
              </div>
            </div>
            <el-image src="../../../static/images/BIMFamilyLibWeb/BIMFamilyLibWeb_005.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
    export default {
        name: "BIMFamilyLibWeb",
        data: function () {
          return {
          }
        },
        components: {

        },
        created() {
        },
        mounted() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        methods: {

        }
    }
</script>

<style scoped>
  .el-main > .el-row {
    min-width: 1108px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/BIMFamilyLibWeb.vue